const scopes = {
  searchRxByPatient: "searchRxByPatient",
  gkvBills: "gkvBills",
  gkvBillEdit: "gkvBillEdit",
  gkvValidation: "gkvValidation",
  gkvSingleRx: "gkvSingleRx",
} as const;

export const insuranceTransactionKeys = {
  searchRxByPatient: {
    scope: scopes.searchRxByPatient,
    all: () => [insuranceTransactionKeys.searchRxByPatient.scope] as const,
    forSearchTerm: (searchTerm: string) =>
      [insuranceTransactionKeys.searchRxByPatient.scope, { searchTerm }] as const,
  },
  gkvBills: {
    scope: scopes.gkvBills,
    all: () => [insuranceTransactionKeys.gkvBills.scope] as const,
    forAccount: (accountId: string) =>
      [insuranceTransactionKeys.gkvBills.scope, { accountId }] as const,
  },
  gkvBillEdit: {
    scope: scopes.gkvBillEdit,
    all: () => [insuranceTransactionKeys.gkvBillEdit.scope] as const,
    forBill: (billId: string) => [insuranceTransactionKeys.gkvBillEdit.scope, { billId }] as const,
    forBillIds: (billIds: string[]) =>
      [insuranceTransactionKeys.gkvBillEdit.scope, { billIds }] as const,
  },
  gkvValidation: {
    scope: scopes.gkvValidation,
    all: () => [insuranceTransactionKeys.gkvValidation.scope] as const,
    forRxIds: (rxIds: string[]) =>
      [insuranceTransactionKeys.gkvValidation.scope, { rxIds }] as const,
  },
  gkvSingleRx: {
    scope: scopes.gkvSingleRx,
    all: () => [insuranceTransactionKeys.gkvSingleRx.scope] as const,
    forRx: (rxId: string) => [insuranceTransactionKeys.gkvSingleRx.scope, { rxId }] as const,
  },
};
